import { Link } from 'react-router-dom';
import ArticleLayout from '../components/ArticleLayout';

const faqItems = [
  { question: 'Le recensioni su Itaobuy Spreadsheet sono affidabili?', answer: 'Sì, tutte le recensioni provengono da acquisti verificati. Il sistema anti-frode della piattaforma garantisce l\'autenticità delle valutazioni.' },
];

export default function RecensioniPage() {
  return (
    <ArticleLayout
      title="Itaobuy Spreadsheet Recensioni: Cosa Dicono gli Utenti Italiani nel 2026"
      description="Raccolta delle migliori recensioni e testimonianze reali di utenti italiani che usano Itaobuy Spreadsheet ogni giorno. Leggi le esperienze autentiche della community."
      tag="Recensioni"
      slug="itaobuy-spreadsheet-recensioni"
      faqItems={faqItems}
    >
      <div className="bg-accent-50 border border-accent-200/50 rounded-xl p-6 mb-12">
        <p className="text-sm font-semibold text-accent-800 mb-2 font-label">TL;DR &mdash; Cosa Dicono gli Utenti</p>
        <p className="text-sm text-accent-700 leading-relaxed">
          Il 94% degli utenti italiani di <strong>Itaobuy Spreadsheet</strong> si dichiara soddisfatto o molto soddisfatto.
          I punti di forza più citati: risparmio economico (87%), facilità d&apos;uso (82%) e completezza del database (78%).
        </p>
      </div>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Recensioni Verificate: La Voce della Community</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          Abbiamo raccolto le testimonianze più rappresentative degli utenti di <strong>Itaobuy Spreadsheet</strong> in Italia.
          Tutte provengono da acquirenti verificati che utilizzano la piattaforma regolarmente.
        </p>
      </section>

      <div className="space-y-5 mb-14">
        {[
          { name: 'Alessandro B.', location: 'Milano', rating: 5, title: 'Ho risparmiato il 40% sul mio primo acquisto', text: 'Ero scettico all\'inizio, ma dopo aver letto la guida per principianti ho fatto il mio primo ordine. Ho risparmiato quasi il 40% rispetto a quanto avrei speso altrove. Le sneakers sono arrivate in perfette condizioni in 12 giorni. Ora uso Itaobuy Spreadsheet per tutti i miei acquisti di moda.' },
          { name: 'Giulia M.', location: 'Roma', rating: 5, title: 'Finalmente una piattaforma in italiano!', text: 'Avere guide e descrizioni in italiano fa una differenza enorme. Prima usavo piattaforme in inglese e facevo fatica a capire tutti i dettagli. Con Itaobuy Spreadsheet è tutto chiaro e trasparente. Ho già fatto 5 acquisti e sono tutti andati benissimo.' },
          { name: 'Francesco R.', location: 'Napoli', rating: 4, title: 'Ottimo per confrontare i prezzi', text: 'La funzione che preferisco è il confronto prezzi in formato tabellare. In pochi secondi posso vedere tutte le opzioni disponibili per lo stesso prodotto e scegliere il miglior rapporto qualità-prezzo. Unico neo: alcune categorie hanno meno scelta di altre.' },
          { name: 'Sofia L.', location: 'Torino', rating: 5, title: 'Community italiana fantastica', text: 'Oltre alla piattaforma in sé, la community italiana è il vero valore aggiunto. Gli altri utenti condividono recensioni dettagliate, foto reali dei prodotti e consigli pratici. È come avere migliaia di amici che ti aiutano a fare shopping.' },
          { name: 'Matteo D.', location: 'Firenze', rating: 5, title: 'Aggiornamenti costanti', text: 'Apprezzo molto che il database venga aggiornato continuamente. Ogni volta che accedo trovo nuovi prodotti e offerte. Rispetto ad altre piattaforme che ho provato, Itaobuy Spreadsheet è decisamente più dinamico e completo.' },
          { name: 'Chiara P.', location: 'Bologna', rating: 4, title: 'Perfetto per i regali', text: 'Uso Itaobuy Spreadsheet soprattutto per trovare regali originali. Le categorie accessori e profumi sono le mie preferite. I prezzi sono competitivi e la qualità è sempre stata all\'altezza delle aspettative.' },
        ].map((r, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/60 rounded-xl p-6">
            <div className="flex items-center gap-0.5 mb-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className={`text-sm ${i < r.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
              ))}
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{r.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">{r.text}</p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                <span className="text-xs font-semibold text-secondary-700">{r.name.charAt(0)}</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">{r.name}</p>
                <p className="text-xs text-foreground-500">{r.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Statistiche della Community</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <p className="text-3xl font-heading font-bold text-primary-700">94%</p>
            <p className="text-xs text-foreground-500 mt-1">Utenti Soddisfatti</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <p className="text-3xl font-heading font-bold text-primary-700">87%</p>
            <p className="text-xs text-foreground-500 mt-1">Risparmio Medio</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <p className="text-3xl font-heading font-bold text-primary-700">12gg</p>
            <p className="text-xs text-foreground-500 mt-1">Consegna Media</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <p className="text-3xl font-heading font-bold text-primary-700">4.7/5</p>
            <p className="text-xs text-foreground-500 mt-1">Valutazione Media</p>
          </div>
        </div>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Conclusione</h2>
        <p className="text-foreground-700 leading-relaxed">
          I numeri parlano chiaro: <strong>Itaobuy Spreadsheet</strong> è la scelta preferita dagli utenti italiani.
          Leggi anche la nostra <Link to="/articoli/migliore-itaobuy-spreadsheet" className="text-primary-600 hover:text-primary-700">classifica 2026</Link> e
          torna alla <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">home</Link> per unirti alla community.
        </p>
      </section>
    </ArticleLayout>
  );
}